// // Custom js for Stern Theme

jQuery(document).ready(function($) {

	//Navigation
	$('.nav-opener').click(function () {
		$('#m-toggle').toggleClass('.nav-active menu');
	});

	//Video feature ajax

	// on page load grab first vid
	$.ajax({
		type: 'POST',
		url: cws.ajaxurl,
		data: {
			action:       'cws_video_ajax_callback',
			video_select: $( '#select:first-child a' ).attr( 'data-code' ),
			image_url:    $( '#select:first-child a' ).attr( 'data-imageurl' ),
		},
		dataType: 'json',

		success: function (response) {

			if( response.success === true ) {

				$( '.video-content' ).html(response.data.shortCode);

				setTimeout( function() {
					$( '.dynamic-img' ).html( '<img src="' + response.data.imageUrl + '"/>' );
					$( '.dynamic-img' ).show();
					$( '.dynamic-img' ).css( 'opacity', '1' );
				});

			}
		},
	});

	//grab vid on click
    $( '#select li a' ).click(function( e ) {
    	e.preventDefault();
		$.ajax({
			type: 'POST',
			url: cws.ajaxurl,
			data: {
				action:       'cws_video_ajax_callback',
				video_select: $( this ).attr( 'data-code' ),
				image_url:    $( this ).attr( 'data-imageurl' ),
			},
			dataType: 'json',

			beforeSend: function() {
				$( '.default-img' ).css( 'opacity', '0' );
				$( '.dynamic-img' ).css( 'opacity', '0' );
				$( '.loader' ).show();
			},

			success: function (response) {

				if( response.success === true ) {

					$( '.video-content' ).html(response.data.shortCode);

					setTimeout( function() {
						$( '.loader' ).hide();
						$( '.default-img' ).hide();
						$( '.dynamic-img' ).html( '<img src="' + response.data.imageUrl + '"/>' );
						$( '.dynamic-img' ).show();
						$( '.dynamic-img' ).css( 'opacity', '1' );
					}, 1000 );

				} else if( response.success === false ) {
					$( '.loader' ).hide();
					alert( response.data );
				}
			},
		});
    });

	//Table of Contents Builder

	var ToC =
  "<nav role='navigation' class='toc'>" +
    "<div class='toc-title'><i class='icon icon-toc'></i> Table of Contents</div>" +
    "<ul>";

	var newLine, el, title, link;

	$("article h2:not('.faq-catname'), .toc-heading").each(function() {

		  el = $(this);
		  title = el.text();
		  link = "#" + el.attr("id");

		  newLine =
		    "<li>" +
		      "<a href='" + link + "'>" +
		        title +
		      "</a>" +
		    "</li>";

		  ToC += newLine;

	});

	ToC +=
	   "</ul>" +
	  "</nav>";

	$(".toc-wrap").prepend(ToC);


	//FAQ Plugin JS
	$('.qa_cats').remove();

	var anchor = $( '.qa-faq-anchor' );

	anchor.click( function() {
		$('.faq-active').removeClass('faq-active');
		$('.qa-faq-anchor').removeClass('faq-active');
		$( this ).toggleClass( 'faq-active' );
	});

	//No comments
	$("#commentform").addClass("noauto");


	// Play video on play

	 $(".modal").on('shown.bs.modal', function (ev) { 
	 	var $this2 = $(this); 
	 	var $frame2 = $this2.find('.modal-content #video_play iframe'); 
	 	$frame2.attr("src", $frame2.attr("src").replace("autoplay=0", "autoplay=1"))
	 });

  	//Stop video on play

	 $(".modal").on('hidden.bs.modal', function (e) { 
	 	var $this = $(this); 
	 	var $frame = $this.find('.modal-content #video_play iframe');
	 	$frame.attr("src", $frame.attr("src").replace("autoplay=1", "autoplay="))
	 	//$frame.attr("src", $frame.attr("src")); 
	 });

	 //Hover for Desktop, click for mobile nav
	 if($(window).width() > 767){
	    $('.dropdown').on('mouseenter mouseleave click tap', function() {
	      $(this).toggleClass("open");
	    });
    } 

	//Slick

	$("#result-slider").slick({
		slidesToShow: 3,
		infinite: true,
		autoplay: true,
		slidesToScroll: 3,
		prevArrow: '<span class="icon icon-chevron-left"></span>',
		nextArrow: '<span class="icon icon-chevron-right"></span>',
		appendArrows: '.customNavigationResults',
		dots: false,
		responsive: [
		    {
		      breakpoint: 1199,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3
		      }
		    },
		    {
		      breakpoint: 991,
		      settings: {
		        slidesToShow: 2,
				slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 767,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        slidesToShow: 1,
				slidesToScroll: 1
		      }
		    }
	  	]
	});

	$("#testimonial-slider").slick({
		infinite: true,
		slidesToShow:1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		appendDots: '.customDots',
		dots: true
	});

	$("#practice-slide").slick({
		slidesToShow: 5,
		infinite: false,
		autoplay: false,
		slidesToScroll: 5,
		initialSlide: 0,
		prevArrow: '<span class="icon-chevron-left-green"></span>',
		nextArrow: '<span class="icon-chevron-right-green"></span>',
		appendArrows: '.customNavigationPractices',
		dots: false,
		responsive: [
		    {
		      breakpoint: 1199,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3,
		        //centerMode: true,
		      }
		    },
		    {
		      breakpoint: 767,
		      settings: {
		        slidesToShow: 2,
				slidesToScroll: 2,
		      }
		    },
			{
		      breakpoint: 480,
		      settings: {
		        slidesToShow: 1,
				slidesToScroll: 1,
		        centerMode: true,
		        centerPadding: 0,
		      }
		    }

	  	],
	});	

	$("#association-rack").slick({
		slidesToShow: 8,
		infinite: false,
		autoplay: false,
		slidesToScroll: 8,
		initialSlide: 0,
		prevArrow: '<span class="icon icon-chevron-left"></span>',
		nextArrow: '<span class="icon icon-chevron-right"></span>',
		//appendArrows: '.customNavigationAwards',
		dots: false,
		variableWidth: true,
		//centerMode: true,
		responsive: [
		    {
		      breakpoint: 1199,
		      settings: {
		        slidesToShow: 6,
				slidesToScroll: 1,
				//centerMode: true,
				variableWidth: false,
		      }
		    },
		    {
		      breakpoint: 991,
		      settings: {
		        slidesToShow: 4,
				slidesToScroll: 1,
				//centerMode: true,
				variableWidth: false,
		      }
		    },

		    {
		      breakpoint: 767,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        centerMode: false,
		        variableWidth: false,
		      }
		    }
	  	]
	});

	$("#sb-association-rack").slick({
		slidesToShow: 2,
		infinite: false,
		autoplay: false,
		slidesToScroll: 2,
		initialSlide: 0,
		prevArrow: '<span class="icon icon-chevron-left"></span>',
		nextArrow: '<span class="icon icon-chevron-right"></span>',
		appendArrows: '.customNavigationAwards',
		dots: false,
		variableWidth: false,
		responsive: [
		    {
		      breakpoint: 1199,
		      settings: {
		        slidesToShow: 1,
				slidesToScroll: 1,
				//centerMode: true,
				variableWidth: false,
		      }
		    },
		    {
		      breakpoint: 991,
		      settings: {
		        slidesToShow: 4,
				slidesToScroll: 4,
				//centerMode: true,
				variableWidth: false,
		      }
		    },

		    {
		      breakpoint: 767,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        centerMode: false,
		        variableWidth: false,
		      }
		    }
	  	]
	});


	 $('#practice-select').bind('change', function () { 
        var url = $(this).val(); 
        if (url != '') { // require a URL
            window.location = url; // redirect
        }
        return false;
    });

	if( $('#m-toggle').length )  {
		$(document).on("scroll", onScroll);		
    }

    function onScroll(event){
    	var scrollPos = $(window).scrollTop();
        if (scrollPos > $('#footer-map-section').offset().top) {
        	$('#m-toggle').addClass("rbottom");
		}
		else {
			$('#m-toggle').removeClass("rbottom");
		}
    }

});


jQuery(window).load(function() {
	jQuery('.wf-active').css({ 'opacity': "0" });
	jQuery('.wf-active').attr('style', 'opacity: 1 !important');
});
